module.exports = __webpack_public_path__ + "static/media/genius.798f21dc.pdf";